jQuery(function($) {

    function selectValueChanged(){
        console.log($(this).val());
        if($(this).val() === '' || $(this).val() === null) {
            $(this).css({color: "#959595"});
        } else {
            $(this).css({color: "#000000"});
        }
    }

    setTimeout(function(){
        $('.select-container select').on('change', selectValueChanged);
        $('.select-container select').trigger('change');
    }, 10);

});